import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
} from "@chakra-ui/react";
import { PlusCirlceButtonWithRef } from "components/Button/PlusCircleButton";
import { TaskAction } from "features/Resources/Task/models";
import { useCallback } from "react";
import { UseFormReturn } from "react-hook-form";

type TASK_ACTION_DEFINITION = {
  label: string;
  taskActionType: TaskAction;
};

const TASK_ACTION_TYPES: TASK_ACTION_DEFINITION[] = [
  {
    label: "Assign Buddy",
    taskActionType: "assign_buddy",
  },
  {
    label: "Add Work Email",
    taskActionType: "create_email_account",
  },
  {
    label: "Add Onboarding Plan",
    taskActionType: "create_onboarding_plan",
  },
  {
    label: "Message Prompt",
    taskActionType: "send_message",
  },
  {
    label: "Complete Form",
    taskActionType: "complete_form",
  },
];

interface AddTemplateTaskActionButtonProps {
  setAutoOpen?: (autoOpen: boolean) => void;
  form: UseFormReturn<any>;
}

export default function AddTemplateTaskActionButton({ form, setAutoOpen }: AddTemplateTaskActionButtonProps) {
  const { setValue } = form;
  const onSelect = useCallback((option: TaskAction) => {
    setAutoOpen?.(true);
    setValue("taskAction", option, { shouldDirty: true });
  }, [setAutoOpen, setValue]);
  return (
    <Menu>
      <MenuButton as={PlusCirlceButtonWithRef} />
      <MenuList>
        {TASK_ACTION_TYPES.map((option) => (
          <MenuItem color="cdsGrey.700" key={option.label} onClick={() => onSelect(option.taskActionType)}>
            {option.label}
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
}
